module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABN0lEQVQ4jZ3SsUuVURjH8Y+XkotIiEOziIP/hBC4FDSdTlOjhGMnaMjFTWiJzhK0SJOCcDg0SX9AY1B/QDQ2SEiISIhcHHpfeX3xei89y+Gc8/t+n+fAASGmhyGmbf9Rg2b9grUQUwoxzXYDIab7EwW15FM8xRb2epmX00yglvwHL7Dc6T7Et9sEM71xB3jfTDKPj1jCZ7zFQi35+1hBI7mHhAvs3ND0SS25XntCiOlOJ/AXd8fAcBBieh1iWoEWfBViOsEvbODxGLhldnB4NUEt+Q0+4PkEuK0jjK4ETS3gwRRwm/3ZF5zjZErBqMlfE8zj05SCzVryRV9whGOcToAPsd9uBr3LXazfAv/Gu1ryqD246SMN/fvOq3iGueZqEY+wWEv+MVbQEc1iiLMGXsHXWvJ5N3cJ3ZxNjlCYEa8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Favicon/favicon-16x16.png
// module id = 693
// module chunks = 114276838955818